import Logo from './Logo';

export default Logo;
export { default as logoWithText } from './logo-with-text.svg';
